import React from 'react';
import "./styles.scss";
import { ImageGridSplitProps, ImageItem } from './props';
import MediaThumbnail from '../MediaThumbnail';
import { GridBadge } from '../ImageGridSingle/components/GridBadge';

function ImageGridSplit({images = [], onGridItemClick, defaultImage, defaultImageLabel, withVideo, videoLabel, onVideoItemClick, badge, imageLoading = 'lazy'}: ImageGridSplitProps) {
  const mainImage = images[0];

  const renderImage = (image: ImageItem, index?: number) => (
    <div 
      key={image.id || index}
      className='image-grid-split__item'
      onClick={onGridItemClick}
    >
      <img src={image.src} alt={image.alt} data-e2e='image-grid-split-image' loading={imageLoading}/>
    </div>
  );

  const renderVideoThumbnail = (image?: ImageItem) => (
    <MediaThumbnail image={image?.src || defaultImage} label={videoLabel} onClick={onVideoItemClick} hover={true}/>
  );

  const renderNoImages = () => {
    return <MediaThumbnail image={defaultImage} label={defaultImageLabel} noMedia={true}/>;
  }

  const renderMainImage = () => {
    if (images.length === 0) {
      if (withVideo) {
        return renderVideoThumbnail(mainImage);
      }
    return renderNoImages();
  }
    
    return renderImage(mainImage);
  };

  const renderVideoGrid = (remainingImages: ImageItem[]) => {
      return (<>
        <div className="image-grid-split__row">
            {renderVideoThumbnail(mainImage)}
            {renderImage(remainingImages[0])}
        
        </div>
        <div className="image-grid-split__row">
          {renderImage(remainingImages[1])}
          {renderImage(remainingImages[2])}
        </div>
      </>)
  }

  const renderRegularGrid = (gridImages: ImageItem[]) => {
    const rows = [];
    
    for (let i = 0; i < gridImages.length; i += 2) {
      const rowImages = gridImages.slice(i, i + 2);
      rows.push(
        <div key={`row-${i}`} className="image-grid-split__row">
          {rowImages.map(renderImage)}
        </div>
      );
    }
    
    return rows;
  };


  const renderRightColumn = () => {
    const remainingImages = images.slice(1);
    const gridImages = remainingImages.slice(0, 4);

    if (images.length === 0) {
      if (withVideo) return renderVideoThumbnail();
      return renderNoImages();
    }
 
    if (remainingImages.length === 0) {
      if (withVideo) return renderVideoThumbnail(mainImage);
      return renderImage(mainImage);
    }

    if (withVideo) {
      if (remainingImages.length >= 3) {
        return renderVideoGrid(remainingImages);
      } else {
        return renderVideoThumbnail(mainImage);
      }
    }
    
    if (remainingImages.length < 4) {
      return renderImage(remainingImages[0]);
    }
   
    return renderRegularGrid(gridImages);
  };

  return (
    <div className="image-grid-split" data-e2e="image-grid-split">
      <GridBadge badge={badge} />
      <div className="image-grid-split__column">{renderMainImage()}</div>
      <div className="image-grid-split__column">{renderRightColumn()}</div>
    </div>
  );
}

export default React.memo(ImageGridSplit);